export default __webpack_public_path__ + "static/media/Q42018.d571da7a.PDF";